// WARNING: This file is auto-generated. Do not edit directly.
import { baseTokens } from './base';
import { responsiveTokens } from './responsive';

export const elevationTokens = {
  shadowMd: {
    x: responsiveTokens.spacing.none,
    y: responsiveTokens.spacing.xs,
    blur: responsiveTokens.spacing.md,
    spread: responsiveTokens.spacing.none,
    color: baseTokens.color.grey.alpha['900']['8'],
  },
  shadowMdLeft: {
    x: responsiveTokens.spacing.xsNegative,
    y: responsiveTokens.spacing.none,
    blur: responsiveTokens.spacing.md,
    spread: responsiveTokens.spacing.none,
    color: baseTokens.color.grey.alpha['900']['8'],
  },
  shadowMdRight: {
    x: responsiveTokens.spacing.xs,
    y: responsiveTokens.spacing.none,
    blur: responsiveTokens.spacing.md,
    spread: responsiveTokens.spacing.none,
    color: baseTokens.color.grey.alpha['900']['8'],
  },
  shadowMdTop: {
    x: responsiveTokens.spacing.none,
    y: responsiveTokens.spacing.xsNegative,
    blur: responsiveTokens.spacing.md,
    spread: responsiveTokens.spacing.none,
    color: baseTokens.color.grey.alpha['900']['8'],
  },
} as const;
export type ElevationTokens = typeof elevationTokens;
